// import "./ExternalMessagePage.css";
import { Card, Grid } from "@mui/material";
import OrderMessages from "../../shared/OrderViewSlider/OrderMessages";
import { Amplify } from "aws-amplify";
import awsconfig from "../../aws-exports";

export default function ExternalMessagePage() {
  Amplify.configure(awsconfig);
  return (
    <Grid
      container
      justifyContent="center"
      p={6}
      sx={{
        height: "100%",
        backgroundImage: "url(/assets/background/background-parnerus.png)",
        backgroundSize: "70%",
      }}
    >
      <Grid item>
        <Card sx={{ padding: 10, width: 600 }}>
          <OrderMessages variant="parnerus" />
        </Card>
      </Grid>
    </Grid>
  );
}
